import React from 'react';

import './save-button.scss';

const SaveButton = ({ onClick, title }: { onClick: () => void; title: string }) => {
    return (
        <span className="save-btn">
            <i className="material-icons link white-text" onClick={onClick} title={title}>
                save
            </i>
        </span>
    );
};

export default SaveButton;
